import { Component, Inject } from '@angular/core';
import { ConfirmationPopupInterface, ConfirmationPopupModel } from './confirmation-popup.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-confirmation-popup',
    templateUrl: './confirmation-popup.component.html',
})
export class ConfirmationPopupComponent {
    data = new ConfirmationPopupModel({} as ConfirmationPopupInterface);

    constructor(@Inject(MAT_DIALOG_DATA) private popupData: ConfirmationPopupInterface) {
        this.data = new ConfirmationPopupModel(popupData);
    }
}

export function openConfirmationDialog(dialog: MatDialog, popupData?: ConfirmationPopupInterface): Observable<boolean> {
    const config = new MatDialogConfig();

    config.autoFocus = false;
    // Use disableClose from popupData, defaulting to true if not specified
    // This prevents accidental dismissal of important confirmation dialogs
    config.disableClose = popupData?.disableClose !== undefined ? popupData.disableClose : true;

    // Width configuration with responsive fallback
    // Priority: customWidth > isResetPasswordAwareness > default
    if (popupData?.customWidth) {
        config.width = popupData.customWidth;
        // Add responsive max-width for mobile (80vw) to prevent overflow
        config.maxWidth = '90vw';
    }
    else {
        config.width = popupData?.isResetPasswordAwareness ? '28.125rem' : '31.25rem';
    }

    // Height configuration with responsive fallback
    if (popupData?.customHeight) {
        // Use customHeight as maxHeight (not fixed height) to allow content-driven sizing
        // Dialog grows naturally with content up to customHeight, then shows scrollbar
        config.maxHeight = popupData.customHeight;
    }
    else {
        // Default max height for mobile responsiveness
        config.maxHeight = '80vh';
    }

    config.panelClass = 'popup-dialog';
    config.data = { ...popupData };

    return dialog.open(ConfirmationPopupComponent, config).afterClosed();
}
